import React, { Fragment } from "react"
import { FixedSizeList as List } from "react-window"
import AutoSizer from "react-virtualized-auto-sizer"
import {
    TableRow,
    TableText,
    TableParagraph,
    HeaderRow,
    HeaderText
} from "./styles"

const renderTable = (data, clickCallback) => {
    const typeTextStyle = type => {
        let style = { color: "#BED47E" }
        switch (type) {
            case "ERROR":
                style.color = "#D7674E"
                break
            case "WARNING":
                style.color = "#FEFEFE"
                break
            case "CRITICAL":
                style.color = "#D74EBE"
                break
            default:
        }
        return style
    }
    const moduleTextStyle = module => {
        const style = module.includes("buildflow")
            ? { color: "#4ebed7" }
            : { color: "#fefefe" }
        return style
    }

    const Row = ({ index, style }) => (
        <div style={style}>
            <TableRow
                style={
                    index === data.length - 1
                        ? { borderBottom: "1px solid white" }
                        : index === 0
                        ? { borderTop: "1px solid white" }
                        : {}
                }
                onClick={() => clickCallback(data[index])}
            >
                <TableText>{data[index].time}</TableText>
                <TableText style={moduleTextStyle(data[index].module)}>
                    {data[index].module}
                </TableText>
                <TableText style={typeTextStyle(data[index].type)}>
                    {data[index].type}
                </TableText>
                <TableParagraph>{data[index].message}</TableParagraph>
            </TableRow>
        </div>
    )

    if (data.length === 0) return <span>No logs found</span>
    return (
        <div
            className="TableContainer"
            style={{
                flex: "1 1 auto",
                width: "90%",
                maxHeight: `85vh`
            }}
        >
            <AutoSizer>
                {({ height, width }) => (
                    <Fragment>
                        <HeaderRow style={{ width: width }}>
                            <HeaderText>
                                <b>TIME</b>
                            </HeaderText>
                            <HeaderText>
                                <b>MODULE</b>
                            </HeaderText>
                            <HeaderText>
                                <b>TYPE</b>
                            </HeaderText>
                            <HeaderText>
                                <b>MESSAGE</b>
                            </HeaderText>
                        </HeaderRow>
                        <List
                            height={height}
                            itemCount={data.length}
                            itemSize={35}
                            width={width}
                            // overscan count is main factor in render time
                            overscanCount={50}
                        >
                            {Row}
                        </List>
                    </Fragment>
                )}
            </AutoSizer>
        </div>
    )
}

export default renderTable



// WEBPACK FOOTER //
// ./src/OctoprintParser/RenderTable/index.js